// Route guard that checks whether the current user belongs to at least one
// of the required Cognito groups before rendering the protected component.
//
// Usage:
//   <RequireGroup groups={['exec_admin', 'supervisor']}>
//     <MyComponent />
//   </RequireGroup>
//
// If the user does not have any of the required groups they are redirected
// to /dashboard. The redirect is silent — no error is shown.
//
// Important: All users are in the team_member group. Groups beyond team_member
// represent additional access grants (supervisor, issued_credit_card, etc.).
// This component checks for those additional grants, not team_member itself.

import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppContext } from '../AppContext.jsx';

export const RequireGroup = ({ groups, children }) => {
  const { store } = useContext(AppContext);
  const userGroups = store?.userData?.groups || [];

  const hasAccess = groups.some(group => userGroups.includes(group));

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

RequireGroup.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};